<script setup>

import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import store from "@/vuex/store";
import Logo from "@/components/icons/Logo.vue";
import ConfirmModal from "@/components/common/ConfirmModal.vue";
import {useRouter} from "vue-router";
import {timeFromTs} from "@/helpers";
import {ElNotification} from "element-plus";

const router = useRouter();

const clips = computed(() => store.getters["live/getClips"])

const isAllLoaded = computed(() => clips.value.filter(clip => clip.loading || clip.failed).length === 0)
const start_time = ref(store.getters["live/getStream"].start_timestamp)
const disabledPreview = computed(() => !clips.value.length || !isAllLoaded.value)
const left_time = ref(0)
const showConfirmCancelModal = ref(false)
const timer = ref()

onMounted(() => {
  timer.value = setInterval(() => {
    updateLeftTime()
  }, 1000)
})

onBeforeUnmount(() => {
  clearInterval(timer.value)
})

function updateLeftTime() {
  left_time.value = (start_time.value + (24 * 3600 * 1000)) - Date.now()
  if(left_time.value < 0) {
    store.dispatch('window/sessionExpired')
  }
}

async function save() {
  let res = await store.dispatch('live/preview')
  if(res?.status === 200 && res.data?.success) {
    ElNotification.success({
      message: 'All clips was successfully saved.',
      offset: 50
    })
  } else {
    console.log(res)
    ElNotification.error({
      message: res.data.message || res.data.erros || 'Something went wrong.',
      offset: 50
    })
  }
}

async function exportClips() {
  // console.log(JSON.stringify(clips.value))
  // return
  let res = await store.dispatch('live/preview')
  if(res?.status === 200 && res.data?.success) {
    router.push({ name: 'preview' })
  } else {
    console.log(res)
  }
}

function cancel() {
  store.dispatch('window/cancelLiveEditing')
}

</script>

<template>
  <header class="fixed top-[58px] shadow-md left-0 z-50 w-full pl-[80px] px-8 py-2 rounded-[4px] bg-white border border-[!F3F4F5]">
    <div class="flex justify-between items-center mx-auto">
      <div class="flex items-center gap-3">
        <Logo class="max-h-[32px]"/>
        <div>
          <h1 class="text-[18px] font-bold tracking-tight text-dark_blue">Live Editor</h1>
        </div>
      </div>

      <div class="flex gap-4 items-center">
        <el-tooltip content="Expire in" popper-class="blue-tooltip" :enterable="false" :hide-after="0">
          <strong class="text-orange-450 text-[12px]">{{timeFromTs(left_time, false, true)}}</strong>
        </el-tooltip>
        <button
          @click="showConfirmCancelModal = true"
          class="group relative px-7 py-3 text-xs font-bold text-white rounded-[4px] cursor-pointer bg-orange-450 hover:bg-orange-450/80 transition"
        >
          Cancel
        </button>
        <button
          @click="save"
          class="group relative px-7 py-3 text-xs font-bold text-white rounded-[4px] cursor-pointer bg-green-450 hover:bg-green-450/80 transition"
        >
          Save
        </button>
        <el-tooltip :content="!clips.length ? 'Creat at least 1 clip' : !isAllLoaded ? 'Wait while we prepare the clips' : 'Preview'"
                    :disabled="!disabledPreview"
                    placement="bottom-end"
                    popper-class="blue-tooltip" :enterable="false" :hide-after="0">
          <button
            @click="exportClips"
            :disabled="disabledPreview"
            class="group relative px-7 py-3 text-xs font-bold text-white rounded-[4px] transition"
            :class="{
              'bg-gray-400 cursor-not-allowed': disabledPreview,
              'bg-blue-450 cursor-pointer hover:bg-blue-450/80' : !disabledPreview,
            }"
          >
            Preview
          </button>
        </el-tooltip>
      </div>
    </div>
  </header>
  <ConfirmModal :isOpen="showConfirmCancelModal"
                content="Are you sure you want to cancel editing? All changes will be lost."
                @close="showConfirmCancelModal = false;"
                @cancel="showConfirmCancelModal = false"
                @confirm="cancel"/>
</template>

